<template>
    <button
            id="filter-button"
            class="inline-flex justify-center w-full rounded-md border border-gray-400 px-4 py-2 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150"
            type="button"
            @click.prevent="excelDownload" >
         <svg-vue class="self-center mr-3 h-4 w-4" icon="font-awesome.file-csv-solid"></svg-vue>
                            {{ $t('Export Excel') }}
          <svg-vue class="self-center ml-2.5 -mr-1.5 h-3 w-3" icon="font-awesome.chevron-right-solid"></svg-vue>
    </button>
   
</template>

<script>

export default {
    name: "ExcelComponent",
    props: {
        method: { type: Function }
    },
    methods: {
        excelDownload: function () {
            this.method();
        }
    }
}
</script>
